import API from "../../helpers/API";
import {
  SET_ALL_ADVERTISEMENTS,
  SHOW_LOADER,
  HIDE_LOADER,
  SET_ALL_EXAMS,
  SET_EXAMS,
  SET_SUBJECTS,
  SET_ALL_REPORT_COUNTS,
  GET_ALL_ANSWER_KEY_DATA,
  ANSWER_KEY_DATA_UPDATED_SUCCESS,
  SET_ALL_UNAPPROVAL_ENTITY_LIST,
  SET_UNAPPROVAL_PAGE_NO_COUNTER,
  ANSWER_KEY_DATA_FOR_APPROVAL,
  GET_ABSENTEE_LIST,
  SET_EXAMINERS_MODERATOR_REPORT_DATA,
  SET_SUPERVISORS,
  SET_DIFFERENTIAL_REPORT_DATA,
  SET_EXAMINERS_AND_MODERATOR_APPROVAL_PAGE_NO_COUNTER,
  SET_EXAMINERS_AND_MODERATOR_APPROVAL_LIST,
  SET_SUPERVISORS_BY_ID,
  SET_ALL_UNAPPROVAL_RULES_LIST,
  SET_UNAPPROVAL_RULE_PAGE_NO_COUNTER,
  SET_ALL_QUESTION_SETS,
  SET_ALL_ANSWER_KEYDATA,
  ANSWER_RULE_DATA_FOR_APPROVAL,
  SET_ALL_ROLL_NUMBER_LIST,
  SET_RULES_CALCULATE_RESULT_DATA,
  SET_MARKS_PDF,
  SET_INTERVIEW_MARKS_LIST,
  SET_ALL_UNAPPROVED_INTERVIEWMARKS_LIST,
  SET_UNAPPROVAL_INTERVIEWMARKS_PAGE_NO_COUNTER,
  SET_DUPLICATES_LIST,
  SET_OUT_OF_RANGE_LIST,
  SET_UNAPPROVAL_DUPLICATE_ROLL_NO_LIST,
  SET_UNAPPROVAL_DUPLICATE_COUNTER,
  SET_UNAPPROVAL_OUT_OF_RANGE_COUNTER,
  SET_UNAPPROVAL_OUT_OF_RANGE_LIST,
  SET_FILE_OBJECT,
  SET_ABSENTEE_LIST,
  SET_UNAPPROVAL_ABSENTEE_LIST,
  SET_UNAPPROVAL_ABSENTEE_LIST_COUNTER,
  SET_VERSION_MISMATCH_LIST,
  SET_UNAPPROVAL_VERSION_MISMATCH_PAGE_NO_COUNTER,
  SET_UNAPPROVAL_VERSION_MISMATCH_LIST,
  SET_MARK_CRITERIA_APPROVAL_LIST,
  SET_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
  GET_ALL_TOTAL_OF_STUDNETS,
  GET_MARK_DIFFERENCE_COUNT,
  SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_LIST,
  SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
  GET_MODERATOR_MARK_COUNT,
  SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_LIST,
  SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
  GET_MODERATOR_CANDIDATE_LIST,
  GET_CHIEF_MODERATOR_CANDIDATE_LIST,
  SET_MODERATOR_CRITERIA_APPROVAL_LIST,
  SET_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
  GET_PERCENTAGE_COUNT,
  SET_OBJECTIVE_STATUS_DATA,
  SET_POST_CRITERIA,
  GET_POSTCRITERIA,
  GET_ALL_VIEW_MARKS,
  GET_QUALIFIED_CANDIDATE,
  SET_MODERATOR_MARK_CRITERIA_STATUS,
  SET_CHIEF_MODERATOR_MARK_CRITERIA_STATUS,
  SET_RESERVED_SEATS_DATA,
  SET_ELIGIBLE_RECOMMANDATION_REPORT_DATA,
  SET_INVIGILATOR_VERSION_MISMATCH_LIST,
  SET_BARCODE_AND_ROLLNO,
  SET_MERITLIST_REPORT_DATA,
  SET_MODERATOR_MODERATION,
  SET_CHIEF_MODERATOR_MODERATION,
  SET_SUBJECT_CODE_ROLLNO,
  SET_EXAM_CODE_ROLLNO,
  SET_CRITERIA_CHECKING_LIST,
  SET_OBJECTIVE_STATUS_DATA_FLAG,
  SET_ANSWER_KEY_SET_LIST,
  SET_QUESTION_SET_LIST,
  SET_PROCESS_LOCK_STATE,
  GET_INTERVIEW_SCRUTINY_CANDIDATES,
  SAVE_INTERVIEW_STATUS
} from "../../common/constants/ActionTypes";
import {
  GETALLEXAMLIST,
  GETCHALLANDETAILS,
  GETALLEXAMSBYADVTID,
  GETALLSUBJECTSBYEXAMID,
  CROSSCHECKCOUNT,
  DOWNLOADCROSSCHECKCOUNT,
  GETALLANSWERKEYDATA,
  STOREANSWERKEY,
  ENTITYAPPROVALACTION,
  ENTITY_APPROVAL,
  ANSWERKEYDATAFORAPPROVAL,
  UPLOADSCANNEDDATA,
  ABSENTEELIST,
  GETALLEXAMINERSREPORTDATA,
  GET_ALL_EXAMINERS_REPORT_DATA,
  UPLOAD_MARKS_CSV,
  UPLOAD_BARCODE_CSV,
  GET_ALL_SUPERVISORS_BY_EXAM_AND_SUBJECT_ID,
  GET_DIFFERENTIAL_REPORT_DATA,
  GET_EXAMINER_AND_MODERATOR_APPROVAL_LIST,
  UPDATE_ALL_EXAMINERS_REPORT_DATA,
  LOCK_UNLOCK_STATUS,
  GETRULESAPPROVALACTION,
  SAVEANSWERRULES,
  GET_ALL_QUESTION_SETS,
  GET_ANSWER_KEY_DATA_LIST,
  GET_ALL_ROLL_NUMBER_LIST_BY_EXAMSUBJECT_ID,
  GET_RULES_CALCULATE_RESULT,
  GET_ALL_MARKS_FOR_PDF,
  GET_INTERVIEW_MARKS_LIST,
  IMPORT_INTERVIEW_MARKS,
  GET_ALL_UNAPPROVAL_INTERVIEW_LIST,
  UPDATE_INTERVIEW_MARKS,
  DUPLICATES,
  UPDATE_DUPLICATE_ROLL_NO,
  OUT_OF_RANGE,
  GET_IMAGE,
  UPDATE_OUT_OF_RANGE,
  UPDATE_ABSENTEE,
  ABSENTEEOBJLIST,
  GET_VERSION_MISMATCH_LIST,
  GET_UNAPPROVED_VERSION_MISMATCH_LIST,
  UPDATE_VERION_MISMATCH_DATA,
  GET_ATTENDANCE_SHEET,
  MARKS_CRITERIA,
  GET_TOTAL_STUDENTS,
  MARK_DIFFERENCE_COUNT,
  CHIEF_MODERATOR_MARK_CRITERIA,
  MODERATOR_MARKS_COUNT,
  MODERATOR_MARK_CRITERIA,
  MODERATOR_CANDIDATE_LIST,
  CHIEF_MODERATOR_CANDIDATE_LIST,
  MODERATOR_PERCENTAGE_CRITERIA,
  GET_OBJECTIVE_STATUS,
  OBJECTIVE_STATUS_LOCK_UNLOCK,
  GET_POST_CRITERIA_BY_EXAM_ID,
  GET_VIEW_MARKS,
  GET_DOWNLOAD_CANDIDATE_LIST,
  MODERATOR_CRITERIA_STATUS,
  CHIEF_MODERATOR_CRITERIA_STATUS,
  GET_RESERVED_SEATS,
  GET_ELIGIBLE_RECOMMANDATION_REPORT,
  GET_INVIGILATOR_VERSION_MISMATCH_LIST,
  GET_ALL_BARCODE_AND_ROLLNO,
  GET_MERIT_LIST_REPORT,
  MODERATOR_MODERATION_NOT_DONE,
  CHIEF_MODERATOR_MODERATION_NOT_DONE,
  GET_SUBJECT_CODE_ROLLNO,
  GET_EXAM_CODE_ROLLNO,
  GET_CRITERIA_CHECKING_LIST,
  UPLOADINTERVIEWDATA,
  GET_OBJECTIVE_STATUS_FLAG,
  ANSWER_KEY_SET_LIST
} from "../../common/constants/endpoints";
import { toastr } from "react-redux-toastr";
import PdfFileDownload from "../../common/components/PdfFileDownload";
import label from "../../common/labels/common_en.json";
import FileDownload from "js-file-download";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2pdf from 'html2pdf.js';
import commonLabels from "../../common/labels/common_en.json";
import { handleError, handleResponseMessage } from "../../common/actions/commonActions";


const generateAndDownloadPDF = (marksMismatchReportDtos, data, role) => {
  const pdf = new jsPDF();

  let dataLabel;
  let reportLabel;

  if (role == "examiner") {
    dataLabel = "Examiner";
    reportLabel = "MARKS MISMATCH REPORT - EXAMINER";
  } else if (role == "moderator") {
    dataLabel = "Moderator";
    reportLabel = "MARKS MISMATCH REPORT - MODERATOR";
  } else if (role == "chiefmoderator") {
    dataLabel = "Chief Moderator";
    reportLabel = "MARKS MISMATCH REPORT - CHIEF MODERATOR";
  }

  // Generate and add header to the PDF
  const headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + data.examName + '</h5><h5>' + reportLabel + '</h5><h5>' + data.subjectName + '</h5></div>';

  // Generate and add table to the PDF
  const tableContent = `
  <div>
    <table class="table" style="border-collapse: collapse; width: 100%;">
      <thead>      
        <tr>
          <th style="border: none; border-top: 1px solid black; border-bottom: 1px solid black; text-align: center;">
            <span>CODE</span><br />
            <span>Sr. No.</span>
          </th>
          <th style="border: none; border-top: 1px solid black; border-bottom: 1px solid black; font-size: small; text-align: center;"><span>${dataLabel}</span><br/><span>Marks</span></th>
          <th style="border: none; border-top: 1px solid black; border-bottom: 1px solid black; font-size: small; text-align: center;">Total</th>
          <th style="border: none; border-top: 1px solid black; border-bottom: 1px solid black; font-size: small; text-align: center;">CODE</th>
          <th style="border: none; border-top: 1px solid black; border-bottom: 1px solid black; font-size: small; text-align: center;"><span>${dataLabel}</span><br/><span>Marks</span></th>
          <th style="border: none; border-top: 1px solid black; border-bottom: 1px solid black; font-size: small; text-align: center;">Total</th>
        </tr>
      </thead>
      <tbody>
        ${marksMismatchReportDtos.map((item, index) => `
          <tr key=${index}>
            <td style="text-align: center; border: none; border-top: 1px solid black; border-bottom: 1px solid black;">
              <span style="font-weight: bold;">${item.code}</span><br />
              <span></span>
            </td>
            <td style="text-align: center; border: none; border-top: 1px solid black; border-bottom: 1px solid black;">${item.mark}</td>
            <td style="text-align: center; border: none; border-top: 1px solid black; border-bottom: 1px solid black;">${item.mark}</td>
          </tr>
        `).join('')}
      </tbody>
    </table>
  </div>
`;

  // Combine header and table into one HTML string
  const htmlContent = headerDiv + tableContent;

  const options = {
    margin: [0.8, 0.4, 0.8, 0.4],
    filename: 'MismatchReport.pdf',
    image: { type: 'jpeg', quality: 0.95 },
    html2canvas: { scale: 3, dpi: 300, letterRendering: true },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
  };

  html2pdf()
    .from(htmlContent)
    .set(options)
    .toPdf()
    .get('pdf')
    .then((pdf) => {
      const totalPages = pdf.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const textX = pageWidth - textWidth - 1;
        const textY = 0.8;
        const currentDate = new Date();
        const formattedDate = currentDate.toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        }).split('/').join('/');
        const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
        const dateX = pageWidth - dateWidth;
        const dateY = 0.6;
        pdf.setFontSize(8);
        pdf.text(formattedDate, dateX, dateY);
        pdf.text(`Page No. ${i}`, dateX, textY);

        const ad = data.advertisementNo; // Use data instead of getDuplicateCodeData
        const headerText = `Advertisement No. ${ad}`;
        const headerX = 0.4;
        const headerY = 0.6;

        pdf.setFontSize(8);
        pdf.text(headerText, headerX, headerY);
      }

      // Save the PDF
      pdf.save(`${dataLabel}MismatchReport.pdf`);
    });
};



export const showLoader = () => {
  return (dispatch) => {
    dispatch({
      type: SHOW_LOADER,
    });
  };
};

export const hideLoader = () => {
  return (dispatch) => {
    dispatch({
      type: HIDE_LOADER,
    });
  };
};

export const uploadScannedData = (
  data,
  selectedReport,
  examId,
  preData,
  setSelectedAdvertNo,
  setSelectedExam,
  setSelectedPreDataImport,
  setSelectedUploadFile
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);
    formData.append("type", data.type);
  }

  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    try {
      response = await API.post(
        `${UPLOADSCANNEDDATA}?examid=${examId}&subjectid=${preData}&reportid=${selectedReport}`,
        formData,
        {
          headers: header,
        }
      );

      setSelectedAdvertNo("");
      setSelectedExam("");
      setSelectedPreDataImport("");
      setSelectedUploadFile("");
      if (response.data !== "") {
        toastr.success(label.SomeErrorsInCsv);
        FileDownload(
          response.data,
          "scanned_Data_" + examId + "_" + preData + ".csv"
        );
      } else {
        toastr.success(label.ImportDataSavedSuccessFully);
      }
    } catch (error) {
      // toastr.error(label.ErrorWhileSave, error.message);
      handleError(error);
    }
  };
};

export const getSubjectlistByExamId = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETALLSUBJECTSBYEXAMID}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_SUBJECTS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());

      const message = error?.response?.data?.message;

      if (message === "Invalid exam id") {
        console.log("Invalid exam id");
        return;
      }

      handleError(error);
    }
  };
};


export const getExamslistByAdvertisementId = (advtId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETALLEXAMSBYADVTID}/${advtId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_EXAMS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getSupervisorlist = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_SUPERVISORS_BY_EXAM_AND_SUBJECT_ID}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        // let supervisorId = response.data.
        // getExaminersAndModeratorReportData()
        dispatch({
          payload: response.data,
          type: SET_SUPERVISORS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getSupervisorlistByExamIdSubjectId = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_SUPERVISORS_BY_EXAM_AND_SUBJECT_ID}?examid=${examId}&subjectid=${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        // let supervisorId = response.data.
        // getExaminersAndModeratorReportData()

        dispatch({
          payload: response.data,
          type: SET_SUPERVISORS_BY_ID,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getExamslist = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(GETALLEXAMLIST, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_EXAMS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAdvertisementsList = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(GETCHALLANDETAILS, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_ADVERTISEMENTS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getPostlistByAdvertisementId = (advtId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GETALLEXAMSBYADVTID}/${advtId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_EXAMS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getReportCountByAdvtIdAndExamId = (
  advertNo,
  axamId,

  setSelectedAdvertNo,
  setSelectedExam
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${CROSSCHECKCOUNT}?examid=${axamId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ALL_REPORT_COUNTS,
        });
        handleResponseMessage(response);
      }
      setSelectedAdvertNo("");
      setSelectedExam("");

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: {},
        type: SET_ALL_REPORT_COUNTS,
      });
      handleError(error);
    }
  };
};

export const getDownloadReportCountByAdvtIdAndExamId = (axamId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${DOWNLOADCROSSCHECKCOUNT}?examid=${axamId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      if (response) {
        const divId = "resultCount";
        const constants = {
          PDFX: 10,
          PDFY: 10,
          CDCPDFWIDTH: 980,
          CDCPDFHEIGHT: 1480,
        };
        const size = [1000, 1700];
        const file_name = "resultCrossCount";

        PdfFileDownload(divId, constants, size, file_name);
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAnswerKeyDataBySubjectId = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GETALLANSWERKEYDATA}${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_ALL_ANSWER_KEY_DATA,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const updateAnswerKeyData = (examId, subjectId, updatedValues) => {
  return async (dispatch) => {
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;
      let response;
      response = await API.post(
        `${STOREANSWERKEY}/${examId}/${subjectId}`,
        updatedValues,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      dispatch({
        type: ANSWER_KEY_DATA_UPDATED_SUCCESS,
      });

      if (response) {
        handleResponseMessage(response);
      }

      // dispatch(getAnswerKeyDataBySubjectId(examId, subjectId));

      // toastr.success(label.AnswerKeyDataUpdatedSuccessfully);
    } catch (error) {
      handleError(error);
    }
  };
};

export const getAllApprovalAnswerKeyListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=answer_key`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVAL_ENTITY_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};
export const OutOfRangeApprovalEntityRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalOutOfRangeListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};
export const AbsentListObjApprovalEntityRequest = (
  requestData,
  setShowModal
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalAbsenteeListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};
export const DuplicateApprovalEntityRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalDuplicateRollNoListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const approvalEntityRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalAnswerKeyListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const approvalExaminerEntity = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalExaminersAndModeratorList(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const AnswerKeyDataForApprovalByEntityId = (entityId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${ANSWERKEYDATAFORAPPROVAL}/${entityId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: ANSWER_KEY_DATA_FOR_APPROVAL,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAbsenteeListByAdvtIdAndExamId = (
  advertNo,
  examId,
  subjectId
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${ABSENTEELIST}?advertisementid=${advertNo}&examid=${examId}&subjectid=${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_ABSENTEE_LIST,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const getDuplicateListByExamIdSubId = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${DUPLICATES}/${examId}/${subjectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_DUPLICATES_LIST,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const getOutOfRangeListByExamIdSubId = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${OUT_OF_RANGE}/${examId}/${subjectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_OUT_OF_RANGE_LIST,
        });

        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const getAbsenteeListByExamIdSubId = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${ABSENTEEOBJLIST}/${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ABSENTEE_LIST,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
      // if (response.data.absentee.length == 0) {
      //   toastr.error("No absentee list found");
      // }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};
export const updateDuplicateRollNoData = (examId, subjectId, updatedValues) => {
  return async (dispatch) => {
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;

      await API.post(`${UPDATE_DUPLICATE_ROLL_NO}`, updatedValues, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // dispatch({
      //   type: ANSWER_KEY_DATA_UPDATED_SUCCESS,
      // });

      // dispatch(getDuplicateListByExamIdSubId(examId, subjectId));

      toastr.success(label.AnswerKeyDataUpdatedSuccessfully);
    } catch (error) {
      handleError(error);
    }
  };
};
export const objetiveStatusLockUnlock = (
  examid,
  status,
  lock,
  selectedSubject,
  handleReset
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(
        `${OBJECTIVE_STATUS_LOCK_UNLOCK}?examid=${examid}&subjectId=${selectedSubject}&status=${status}&lock=${lock}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      let successMessage =
        response && response.data ? response.data : response.message;
      toastr.success(successMessage);

      if (status == "absent") {
        dispatch(getAbsenteeListByExamIdSubId(examid, selectedSubject));
      }
      if (status == "duplicate") {
        dispatch(getDuplicateListByExamIdSubId(examid, selectedSubject));
      }
      if (status == "outofrange") {
        dispatch(getOutOfRangeListByExamIdSubId(examid, selectedSubject));
      }
      if (status == "versionmismatch") {
        dispatch(getVersionMismatchList(examid, selectedSubject));
      }
      dispatch(getObjectiveStatus(examid, selectedSubject)); handleReset()
    } catch (error) {
      handleError(error);
    }
  };
};

// export const objetiveStatusLockUnlock = (
//   examid,
//   status,
//   lock,
//   selectedSubject,
//   handleReset
// ) => {
//   return async (dispatch) => {
//     const session = JSON.parse(sessionStorage.getItem("session"));
//     let token = session.jwtResponse && session.jwtResponse.token;
//     let response;
//     try {
//       response = await API.patch(
//         `${OBJECTIVE_STATUS_LOCK_UNLOCK}?examid=${examid}&status=${status}&lock=${lock}`,
//         {},
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );

//       // setShowModal(false);
//       // dispatch(getAllUnApproveRulesListPagination(0, 10));

//       let successMessage =
//         response && response.data ? response.data : response.message;
//       toastr.success(successMessage);
//       if (status == "absent") {
//         dispatch(getAbsenteeListByExamIdSubId(examid, selectedSubject));
//       }
//       if (status == "duplicate") {
//         dispatch(getDuplicateListByExamIdSubId(examid, selectedSubject));
//       }
//       if (status == "outofrange") {
//         dispatch(getOutOfRangeListByExamIdSubId(examid, selectedSubject));
//       }
//       if (status == "versionmismatch") {
//         dispatch(getVersionMismatchList(examid, selectedSubject));
//       }
//       dispatch(getObjectiveStatus(examid))
//       handleReset()
//     } catch (error) {
//       handleError(error);
//     }
//   };
// };

export const updatAbsenteeListData = (examId, subjectId, updatedValues) => {
  return async (dispatch) => {
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;

      await API.post(`${UPDATE_ABSENTEE}`, updatedValues, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // dispatch(getAbsenteeListByExamIdSubId(examId, subjectId));

      toastr.success(label.AnswerKeyDataUpdatedSuccessfully);
    } catch (error) {
      handleError(error);
    }
  };
};
export const updatOutOfRangeData = (examId, subjectId, updatedValues) => {
  return async (dispatch) => {
    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;
      let response;
      response = await API.post(`${UPDATE_OUT_OF_RANGE}`, updatedValues, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // dispatch(getOutOfRangeListByExamIdSubId(examId, subjectId));
      toastr.success(label.AnswerKeyDataUpdatedSuccessfully);

    } catch (error) {
      handleError(error);
    }
  };
};
export const getAllApprovalDuplicateRollNoListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=duplicate`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_UNAPPROVAL_DUPLICATE_ROLL_NO_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_UNAPPROVAL_DUPLICATE_ROLL_NO_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_DUPLICATE_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_UNAPPROVAL_DUPLICATE_ROLL_NO_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalAbsenteeListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=objective_absentee`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_UNAPPROVAL_ABSENTEE_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_UNAPPROVAL_ABSENTEE_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_ABSENTEE_LIST_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_UNAPPROVAL_ABSENTEE_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalOutOfRangeListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${ENTITYAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=out_of_range`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_UNAPPROVAL_OUT_OF_RANGE_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_UNAPPROVAL_OUT_OF_RANGE_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_OUT_OF_RANGE_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_UNAPPROVAL_OUT_OF_RANGE_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAnswerKeyList = (examId, subjectId, questionSet) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ANSWER_KEY_DATA_LIST}?examid=${examId}&subjectid=${subjectId}&setid=${questionSet}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_ALL_ANSWER_KEYDATA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch({
        payload: {},
        type: SET_ALL_ANSWER_KEYDATA,
      });
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

// export const getQuestionSets = () => {
//   return async (dispatch) => {
//     dispatch(showLoader());
//     const session = JSON.parse(sessionStorage.getItem("session"));
//     let token = session.jwtResponse && session.jwtResponse.token;
//     try {
//       let response = await API.get(`${GET_ALL_QUESTION_SETS}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response) {
//         dispatch({
//           payload: response.data,
//           type: SET_ALL_QUESTION_SETS,
//         });
//       }
//       dispatch(hideLoader());
//     } catch (error) {
//       dispatch(hideLoader());
//       handleError(error);
//     }
//   };
// };

export const saveAnswerRules = (
  examId,
  subjectId,
  questionSetId,
  requestData,
  examList,
  advertisementList,
  questionSetList,
  subjectList,
  answerKeyDataList,
  isRuleAlreadySet
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      if (isRuleAlreadySet == false) {
        await API.post(
          `${SAVEANSWERRULES}?examid=${examId}&subjectid=${subjectId}&setid=${questionSetId}`,
          requestData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else {
        await API.patch(
          `${SAVEANSWERRULES}?examid=${examId}&subjectid=${subjectId}&setid=${questionSetId}`,
          requestData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }

      toastr.success(label.SuccessfullySave);
      examList.length = 0;
      advertisementList.length = 0;
      questionSetList.length = 0;
      subjectList.length = 0;
      answerKeyDataList.answerKey = null;
      answerKeyDataList.answerKeyRule = null;
    } catch (error) {
      handleError(error);
    }
  };
};

export const getAllUnApproveRulesListPagination = (pageNumber, rowPerPage) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GETRULESAPPROVALACTION}/${pageNumber}/${rowPerPage}?entitytypes=answer_key_rule`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVAL_RULES_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVAL_RULES_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_RULE_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVAL_RULES_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const AnswerRuleDataForApprovalByEntityId = (entityId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${ANSWERKEYDATAFORAPPROVAL}/${entityId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: ANSWER_RULE_DATA_FOR_APPROVAL,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const approvalEntityRuleRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllUnApproveRulesListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const getAllRollNumberList = (examId, subjectId, setId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_ROLL_NUMBER_LIST_BY_EXAMSUBJECT_ID}?examid=${examId}&subjectid=${subjectId}&setid=${setId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_ALL_ROLL_NUMBER_LIST,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getRulesCalculatedResult = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_RULES_CALCULATE_RESULT}?examid=${examId}&subjectid=${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_RULES_CALCULATE_RESULT_DATA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

// export const getObjectiveStatus = (examId, setSaveButtonFlag) => {
//   return async (dispatch) => {
//     dispatch(showLoader());
//     const session = JSON.parse(sessionStorage.getItem("session"));
//     let token = session.jwtResponse && session.jwtResponse.token;
//     try {
//       let response = await API.get(`${GET_OBJECTIVE_STATUS}?examid=${examId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response) {
//         dispatch({
//           payload: response.data,
//           type: SET_OBJECTIVE_STATUS_DATA,
//         });
//       }
//       dispatch(hideLoader());
//     } catch (error) {
//       dispatch(hideLoader());
//       dispatch({
//         payload: [],
//         type: SET_OBJECTIVE_STATUS_DATA,
//       });
//       handleError(error);
//     }
//   };
// };

export const getObjectiveStatus = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());

    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session.jwtResponse?.token;

    try {
      const response = await API.get(
        `${GET_OBJECTIVE_STATUS}?examid=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response?.data) {
        // Existing Objective Status
        dispatch({
          type: SET_OBJECTIVE_STATUS_DATA,
          payload: response.data,
        });

        // Process Lock State
        dispatch({
          type: SET_PROCESS_LOCK_STATE,
          payload: {
            absent: response.data.flgAbsentLocked,
            duplicate: response.data.flgDuplicateLocked,
            outOfRange: response.data.flgOutOfRangeLocked,
            versionMismatch: response.data.flgVersionMismatchLocked,
            result: response.data.flgResultGenerated,
            seatMatrix: response.data.flgSeatMatrixLocked,
          },
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());

      dispatch({
        type: SET_OBJECTIVE_STATUS_DATA,
        payload: [],
      });

      handleError(error);
    }
  };
};

export const getReservedSeats = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_RESERVED_SEATS}?examid=${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_RESERVED_SEATS_DATA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: {},
        type: SET_RESERVED_SEATS_DATA,
      });
      handleError(error);
    }
  };
};

export const getExaminersAndModeratorReportData = (
  examId,
  subjectId,
  supervisor
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_EXAMINERS_REPORT_DATA}${examId}/${subjectId}/${supervisor}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_EXAMINERS_MODERATOR_REPORT_DATA,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
      // if (response.data && response.data.message) {
      //   toastr.error(response.data.message);
      // }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const saveMarksCriteria = (
  examId,
  subjectId,
  supervisorId,
  formData
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      await API.post(
        `${MARKS_CRITERIA}/${examId}/${subjectId}/${supervisorId}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const saveModeratorMarksCriteria = (examId, subjectId, formData, moderatorCriteriaStatus) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      if (moderatorCriteriaStatus) {
        await API.patch(
          `${MODERATOR_MARK_CRITERIA}/${examId}/${subjectId}`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      } else {
        await API.post(
          `${MODERATOR_MARK_CRITERIA}/${examId}/${subjectId}`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }

      dispatch(hideLoader());
      toastr.success("Entity record added successfully for approval.");
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getModeratorCriteriaStatus = (selectedExam, selectedValue) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${MODERATOR_CRITERIA_STATUS}/${selectedExam}/${selectedValue}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_MODERATOR_MARK_CRITERIA_STATUS,
        });
      }

      dispatch(hideLoader());
      if (response.data && response.data.message) {
        toastr.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: {},
        type: SET_MODERATOR_MARK_CRITERIA_STATUS,
      });
      handleError(error);
    }
  };
};

export const getChiefModeratorCriteriaStatus = (selectedExam, selectedValue) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${CHIEF_MODERATOR_CRITERIA_STATUS}/${selectedExam}/${selectedValue}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_CHIEF_MODERATOR_MARK_CRITERIA_STATUS,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
      // if (response.data && response.data.message) {
      //   toastr.error(response.data.message);
      // }
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: {},
        type: SET_CHIEF_MODERATOR_MARK_CRITERIA_STATUS,
      });
      handleError(error);
    }
  };
};


export const saveChiefModeratorMarksCriteria = (
  examId,
  subjectId,
  formData,
  chiefModeratorCriteriaStatus
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      if (chiefModeratorCriteriaStatus) {
        await API.patch(
          `${CHIEF_MODERATOR_MARK_CRITERIA}/${examId}/${subjectId}`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }
      else {
        await API.post(
          `${CHIEF_MODERATOR_MARK_CRITERIA}/${examId}/${subjectId}`,
          formData,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
      }

      dispatch(hideLoader());
      toastr.success("Entity record added successfully for approval.");
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const patchMarksCriteria = (
  examId,
  subjectId,
  supervisorId,
  formData
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      await API.patch(
        `${MARKS_CRITERIA}/${examId}/${subjectId}/${supervisorId}`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getMarksCriteriaBySupervisor = (
  examId,
  subjectId,
  supervisor = 2
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_EXAMINERS_REPORT_DATA}${examId}/${subjectId}/${supervisor}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_EXAMINERS_MODERATOR_REPORT_DATA,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const updateExaminersAndModeratorMarksData = (
  examId,
  subjectId,
  selectedSupervisor,
  updatedValues
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      // const updatedData = Object.entries(updatedValues).reduce((accumulator, [questionNo, answer]) => {
      //     const adjustedQuestionNo = parseInt(questionNo, 10) + 1;
      //     if (Array.isArray(answer)) {
      //         accumulator[`ans${adjustedQuestionNo}`] = answer.join(",");
      //     } else {
      //         accumulator[`ans${adjustedQuestionNo}`] = answer;
      //     }
      //     return accumulator;
      // }, {});

      const updatedData = {
        examId: examId,
        subjectId: subjectId,
        supervisorId: selectedSupervisor,
        marks: [...updatedValues],
        isActive: 1,
        isDeleted: 0,
      };

      response = await API.post(`${UPDATE_ALL_EXAMINERS_REPORT_DATA}`, updatedData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // dispatch({
      //     type: ANSWER_KEY_DATA_UPDATED_SUCCESS,
      // });

      // dispatch(getAnswerKeyDataBySubjectId(examId, subjectId));

      // if (selectedSupervisor === "1") {
      //   toastr.success(label.ExaminerDataUpdatedSuccessfully);
      // } else if (selectedSupervisor === "2") {
      //   toastr.success(label.ModeratorDataUpdatedSuccessfully);
      // } else if (selectedSupervisor === "3") {
      //   toastr.success(label.ChiefModeratorDataUpdatedSuccessfully);
      // }
      if (response) {
        handleResponseMessage(response);
      }

    } catch (error) {
      handleError(error);
    }
  };
};

export const getAllApprovalExaminersAndModeratorList = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_EXAMINER_AND_MODERATOR_APPROVAL_LIST}/${pageNumber}/${rowPerPage}?entitytypes=mark`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_EXAMINERS_AND_MODERATOR_APPROVAL_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            // let parentdetails = item.entityApproval && item.entityApproval.parentDetails && JSON.parse(item.entityApproval.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            // response.data.entityApprovalDtoList[index].entityApproval.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_EXAMINERS_AND_MODERATOR_APPROVAL_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_EXAMINERS_AND_MODERATOR_APPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_EXAMINERS_AND_MODERATOR_APPROVAL_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalMarksCriteria = (pageNumber, rowPerPage) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_EXAMINER_AND_MODERATOR_APPROVAL_LIST}/${pageNumber}/${rowPerPage}?entitytypes=mark_criteria`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_MARK_CRITERIA_APPROVAL_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            // let parentdetails = item.entityApproval && item.entityApproval.parentDetails && JSON.parse(item.entityApproval.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            // response.data.entityApprovalDtoList[index].entityApproval.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_MARK_CRITERIA_APPROVAL_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_MARK_CRITERIA_APPROVAL_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalChiefModeratorMarksCriteria = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_EXAMINER_AND_MODERATOR_APPROVAL_LIST}/${pageNumber}/${rowPerPage}?entitytypes=mark_criteria`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            // let parentdetails = item.entityApproval && item.entityApproval.parentDetails && JSON.parse(item.entityApproval.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            // response.data.entityApprovalDtoList[index].entityApproval.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_CHIEF_MODERATOR_MARK_CRITERIA_APPROVAL_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalChiefModeratorCriteria = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_EXAMINER_AND_MODERATOR_APPROVAL_LIST}/${pageNumber}/${rowPerPage}?entitytypes=chief_moderator_criteria`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            // let parentdetails = item.entityApproval && item.entityApproval.parentDetails && JSON.parse(item.entityApproval.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            // response.data.entityApprovalDtoList[index].entityApproval.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_CHIEF_MODERATOR_CRITERIA_APPROVAL_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const getAllApprovalModeratorCriteria = (pageNumber, rowPerPage) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_EXAMINER_AND_MODERATOR_APPROVAL_LIST}/${pageNumber}/${rowPerPage}?entitytypes=moderator_criteria`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_MODERATOR_CRITERIA_APPROVAL_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            // let parentdetails = item.entityApproval && item.entityApproval.parentDetails && JSON.parse(item.entityApproval.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            // response.data.entityApprovalDtoList[index].entityApproval.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_MODERATOR_CRITERIA_APPROVAL_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_MODERATOR_CRITERIA_APPROVAL_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_MODERATOR_CRITERIA_APPROVAL_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};



export const getDifferentialReport = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_DIFFERENTIAL_REPORT_DATA}${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_DIFFERENTIAL_REPORT_DATA,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const uploadMarksCsv = (
  data,
  examId,
  subjectId,
  supervisor,
  cancelModal,
  resetData,
  role
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);

    if (role == "examiner") {
      formData.append("type", "examinerMark");
    } else if (role == "moderator") {
      formData.append("type", "moderatorMark");
    } else if (role == "chiefmoderator") {
      formData.append("type", "chiefModeratorMark");
    }
  }

  formData.append("selectedCriteria", data.selectedCriteria);
  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };

  return async (dispatch) => {
    try {
      response = await API.post(
        `${UPLOAD_MARKS_CSV}/${examId}/${subjectId}/${supervisor}`,
        formData,
        {
          headers: header,
        }
      );
      if (response) {
        cancelModal();
        resetData();
        handleResponseMessage(response);
        if (response.data && response.data.marksMismatchReportDtos && response.data.marksMismatchReportDtos.length > 0) {
          // If marksMismatchReportDtos is present, generate and download PDF
          generateAndDownloadPDF(response.data.marksMismatchReportDtos, response.data, role);
        }
      }

      if (data) {

        if (response.data.totalCount !== undefined) {

          const count = response.data.totalCount;

          if (count) {
            const successMessage = count === 0
              ? 'No records added.'
              : `${count} records have been added successfully.`;

            toastr.success(successMessage);
          } else {
            const successMessage = count === 0
              ? 'No records added.'
              : `${count} records have been added successfully.`;

            toastr.success(successMessage);
          }
        }

      }
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.response?.data ||
        "Internal Server Error";

      toastr.error(message);
    }
  };
};

export const uploadBarcodeCsv = (
  data,
  examId,
  subjectId,
  cancelModal,
  resetData
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);
    formData.append("type", "barcodeRollNo");
  }
  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };

  return async (dispatch) => {
    try {
      response = await API.post(
        `${UPLOAD_BARCODE_CSV}/${examId}/${subjectId}`,
        formData,
        {
          headers: header,
        }
      );

      if (response) {
        cancelModal();
        resetData();
      }

      if (data) {
        // dispatch({
        //     type: SET_UPLOAD_CSV,
        //     payload: response.data
        // })
        // if (response?.data?.venueCsvDtoList.length > 0) {

        //     toastr.error("Please check the errors in downloaded file. Provide all relevent information and try again.");
        //     if (data.action == "save") {
        //         dispatch(resetVenueErrorList());
        //     }
        // }
        if (response.data !== "") {
          const lines = response.data.split('\n');
          const count = parseInt(lines[0].split(':')[1].trim());

          let successMessage;

          if (lines.length > 3) {
            successMessage = count === 0
              ? 'No records added.'
              : `${count} records have been added successfully.`;

            const errorCsvContent = lines.slice(3).join('\n');
            FileDownload(errorCsvContent, `Data_barcodeRollNo.csv`);
          } else {
            successMessage = count === 0
              ? 'No records added.'
              : `${count} records have been added successfully.`;
          }

          if (count === 0) {
            toastr.warning(successMessage);
          } else {
            toastr.success(successMessage);
          }
        }


        // if (data.action == "upload") {
        //   toastr.success(label.ImportDataSavedSuccessFully);
        // }
      }
    } catch (error) {
      handleError(error);
    }
  };
};

export const requestForLockUnlockStatus = (
  examId,
  subjectId,
  supervisorId,
  status,
  onCancelButton,
  req
) => {
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      const token = session?.jwtResponse?.token;
      const response = await API.patch(
        `${LOCK_UNLOCK_STATUS}/${examId}/${subjectId}/${supervisorId}/${status}`,
        req,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        toastr.success(response.data);
        onCancelButton();
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getExaminersAndModeratorReportDataPDF = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ALL_MARKS_FOR_PDF}/${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_MARKS_PDF,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getExaminersAndModeratorMarksPDF = (axamId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const divId = "AnswerKey";
      const constants = {
        PDFX: 10,
        PDFY: 10,
        CDCPDFWIDTH: 980,
        CDCPDFHEIGHT: 1480,
      };
      const size = [1000, 1700];
      const file_name = "examinersAndModeratorMarks";

      PdfFileDownload(divId, constants, size, file_name);

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getInterviewMarksList = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_INTERVIEW_MARKS_LIST}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_INTERVIEW_MARKS_LIST,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getAllUnApproveInterviewMarksListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_ALL_UNAPPROVAL_INTERVIEW_LIST}/${pageNumber}/${rowPerPage}?entitytypes=interview_mark`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_ALL_UNAPPROVED_INTERVIEWMARKS_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;
            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_ALL_UNAPPROVED_INTERVIEWMARKS_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_INTERVIEWMARKS_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_ALL_UNAPPROVED_INTERVIEWMARKS_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const uploadInterviewMarksData = (data, examId, setSelectedExam) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);
    formData.append("type", data.type);
  }

  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };
  return async (dispatch) => {
    try {
      response = await API.post(
        `${IMPORT_INTERVIEW_MARKS}/${examId}`,
        formData,
        {
          headers: header,
        }
      );

      setSelectedExam("");

      if (response.data !== "") {
        toastr.success(label.SomeErrorsInCsv);
        FileDownload(response.data, "Interview_Marks_Data_" + examId + ".csv");
      } else {
        toastr.success(label.ImportDataSavedSuccessFully);
      }
    } catch (error) {
      toastr.error(label.ErrorWhileSave, error.message);
    }
  };
};

export const updateIntervewMarks = (
  examId,
  data,
  rowPerPage,
  setIsEditable
) => {
  const session =
    sessionStorage.getItem("session") != null
      ? JSON.parse(sessionStorage.getItem("session"))
      : "";
  let token = session.jwtResponse && session.jwtResponse.token;

  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  };
  return async (dispatch) => {
    try {
      response = await API.post(`${UPDATE_INTERVIEW_MARKS}/${examId}`, data, {
        headers: header,
      });

      if (response) {
        toastr.success(response.data.message);
        setIsEditable(false);
        dispatch(getAllUnApproveInterviewMarksListPagination(0, rowPerPage));
      }
    } catch (error) {
      // toastr.error(label.ErrorWhileSave, error.message);
      handleError(error);
    }
  };
};

export const getPdfData = (examId, subjectId, venueName) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_ATTENDANCE_SHEET}/${examId}/${subjectId}/${venueName}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_FILE_OBJECT,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getImageData = (recordId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_IMAGE}/${recordId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data.image,
          type: SET_FILE_OBJECT,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getVersionMismatchList = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_VERSION_MISMATCH_LIST}/${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_VERSION_MISMATCH_LIST,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
      // if (response.data.versionList.length == 0) {
      //   toastr.error("No version missmatch found");
      // }
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_VERSION_MISMATCH_LIST,
      });
      handleError(error);
    }
  };
};


export const getInvigilatorVersionMismatchList = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_INVIGILATOR_VERSION_MISMATCH_LIST}/${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_INVIGILATOR_VERSION_MISMATCH_LIST,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
      // if (response.data.versionList.length == 0) {
      //   toastr.error("No version missmatch found");
      // }
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
      dispatch({
        payload: [],
        type: SET_INVIGILATOR_VERSION_MISMATCH_LIST,
      });
    }
  };
};

export const getAllUnApproveVersionMismatchListPagination = (
  pageNumber,
  rowPerPage
) => {
  return async function (dispatch) {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.get(
        `${GET_UNAPPROVED_VERSION_MISMATCH_LIST}/${pageNumber}/${rowPerPage}?entitytypes=version_mismatch`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let allDone = false;
      if (response) {

        if (response.data.approvalEmpty === true) {
          dispatch({
            type: SET_UNAPPROVAL_VERSION_MISMATCH_LIST,
            payload: {},
          });
        }

        response &&
          response.data &&
          response.data.entityApprovalDtoList &&
          response.data.entityApprovalDtoList.map((item, index) => {
            let details =
              item.entityApprovalAction &&
              item.entityApprovalAction.entityApprovalDto &&
              item.entityApprovalAction.entityApprovalDto.detail &&
              JSON.parse(item.entityApprovalAction.entityApprovalDto.detail);
            let parentdetails =
              item.entityApprovalAction &&
              item.entityApprovalAction.parentDetails &&
              JSON.parse(item.entityApprovalAction.parentDetails);

            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.entityApprovalDto.detail = details;
            response.data.entityApprovalDtoList[
              index
            ].entityApprovalAction.parentdetails = parentdetails;

            if (index == response.data.entityApprovalDtoList.length - 1) {
              allDone = true;
            }
            if (allDone) {
              dispatch({
                type: SET_UNAPPROVAL_VERSION_MISMATCH_LIST,
                payload: response.data,
              });
              dispatch({
                type: SET_UNAPPROVAL_VERSION_MISMATCH_PAGE_NO_COUNTER,
                payload: pageNumber * rowPerPage,
              });
            } else {
              dispatch({
                type: SET_UNAPPROVAL_VERSION_MISMATCH_LIST,
                payload: {},
              });
              dispatch({
                type: SET_UNAPPROVAL_VERSION_MISMATCH_PAGE_NO_COUNTER,
                payload: 0,
              });
            }
          });
        handleResponseMessage(response);
      }
    } catch (error) {
      dispatch({
        type: SET_UNAPPROVAL_VERSION_MISMATCH_LIST,
        payload: {},
      });
      handleError(error);
    }
  };
};

export const saveVersionMismatch = (requestData, selectedExam, selectedSubject) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.post(`${UPDATE_VERION_MISMATCH_DATA}/${selectedExam}/${selectedSubject}`, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      let successMessage =
        response && response.data ? response.data.message : response.message;
      toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const approvalVersionRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllUnApproveVersionMismatchListPagination(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const approvalModeratorCriteriaRequest = (requestData, setShowModal) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalModeratorCriteria(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const approvalChiefModeratorCriteriaRequest = (
  requestData,
  setShowModal
) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    let response;
    try {
      response = await API.patch(ENTITY_APPROVAL, requestData, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowModal(false);
      dispatch(getAllApprovalChiefModeratorCriteria(0, 10));

      if (response) {
        handleResponseMessage(response);
      }
      // let successMessage =
      //   response && response.data ? response.data.message : response.message;
      // toastr.success(successMessage);
    } catch (error) {
      handleError(error);
    }
  };
};

export const getDownloadVersionMismatch = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const divId = "versionMismatchData";
      const constants = {
        PDFX: 10,
        PDFY: 10,
        CDCPDFWIDTH: 980,
        CDCPDFHEIGHT: 1480,
      };
      const size = [1000, 1700];
      const file_name = "versionMismatch";

      PdfFileDownload(divId, constants, size, file_name);

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getTotalStudentsByExamIdSubjectId = (
  examId,
  subjectId,
  minMark,
  maxMark
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_TOTAL_STUDENTS}/${examId}/${subjectId}/${minMark}/${maxMark}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_ALL_TOTAL_OF_STUDNETS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const generateMarksCalculationPdf = (axamId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const divId = "marksCalculationData";
      const constants = {
        PDFX: 10,
        PDFY: 10,
        CDCPDFWIDTH: 980,
        CDCPDFHEIGHT: 1480,
      };
      const size = [1000, 1700];
      const file_name = "result_" + axamId;

      PdfFileDownload(divId, constants, size, file_name);

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getCandidateCountByExamIdSubjectId = (
  examId,
  subjectId,
  markDifference
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${MARK_DIFFERENCE_COUNT}/${examId}/${subjectId}?markDifference=${markDifference}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_MARK_DIFFERENCE_COUNT,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getModeratorCandidateCountByExamIdSubjectId = (
  examId,
  subjectId,
  marksData,
  moderatorCount,
  setModeratorCount,
  index
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.post(
        `${MODERATOR_MARKS_COUNT}/${examId}/${subjectId}`,
        [marksData],
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      let moderatorMarks = [...moderatorCount];
      moderatorMarks[index] = response.data;
      if (response) {
        dispatch({
          payload: moderatorMarks,
          type: GET_MODERATOR_MARK_COUNT,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getModeratorCandidateCountByPercentage = (
  examId,
  subjectId,
  formPercentageData
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      let response = await API.post(
        `${MODERATOR_PERCENTAGE_CRITERIA}/${examId}/${subjectId}`,
        formPercentageData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        dispatch({
          payload: response.data,
          type: GET_PERCENTAGE_COUNT,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getModeratorCandidateListByExamIdSubjectId = (
  examId,
  subjectId,
  downloadCSV,
  onCancelButton
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${MODERATOR_CANDIDATE_LIST}/${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data.markList,
          type: GET_MODERATOR_CANDIDATE_LIST,
        });
        downloadCSV(response.data.markList);
        onCancelButton();
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getChiefModeratorCandidateListByExamIdSubjectId = (
  examId,
  subjectId,
  downloadCSV,
  onCancelButton
) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${CHIEF_MODERATOR_CANDIDATE_LIST}/${examId}/${subjectId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data.marksListDtos,
          type: GET_CHIEF_MODERATOR_CANDIDATE_LIST,
        });
        downloadCSV(response.data.marksListDtos);
        onCancelButton();
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getPostCriteria = () => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(GETALLEXAMLIST, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_POST_CRITERIA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

export const getPostCriteriaByAdvertisementId = (advId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_POST_CRITERIA_BY_EXAM_ID}/${advId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: GET_POSTCRITERIA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getCriteriaCheckingByAdvertisementId = (advId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_CRITERIA_CHECKING_LIST}/${advId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_CRITERIA_CHECKING_LIST,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getEligibleRecommandationReport = (advId, examId, postCriteriaId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_ELIGIBLE_RECOMMANDATION_REPORT}?advertisementid=${advId}&examid=${examId}&postcriteriaid=${postCriteriaId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ELIGIBLE_RECOMMANDATION_REPORT_DATA,
        });
        handleResponseMessage(response);
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_ELIGIBLE_RECOMMANDATION_REPORT_DATA,
      });
      handleError(error);
    }
  };
};


export const getMeritListReport = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_MERIT_LIST_REPORT}?examid=${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        handleResponseMessage(response);
        dispatch({
          payload: response.data,
          type: SET_MERITLIST_REPORT_DATA,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: [],
        type: SET_MERITLIST_REPORT_DATA,
      });
      handleError(error);
    }
  };
};

export const getViewResult = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_VIEW_MARKS}?examid=${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {

        dispatch({
          payload: response.data,
          type: GET_ALL_VIEW_MARKS,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getdownloadCandidateList = (examId, downloadCSV) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(
        `${GET_DOWNLOAD_CANDIDATE_LIST}/${examId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response) {
        downloadCSV(response.data)
        dispatch({
          payload: response.data,
          type: GET_QUALIFIED_CANDIDATE,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getBarcodeAndRollNo = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_ALL_BARCODE_AND_ROLLNO}/${examId}/${subjectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_BARCODE_AND_ROLLNO,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getModeratorModeration = (selectedExam, selectedValue) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${MODERATOR_MODERATION_NOT_DONE}/${selectedExam}/${selectedValue}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_MODERATOR_MODERATION,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
      // if (response.data && response.data.message) {
      //   toastr.error(response.data.message);
      // }
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: {},
        type: SET_MODERATOR_MODERATION,
      });
      handleError(error);
    }
  };
};


export const getChiefModeratorModeration = (selectedExam, selectedValue) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;

    try {
      let response = await API.get(
        `${CHIEF_MODERATOR_MODERATION_NOT_DONE}/${selectedExam}/${selectedValue}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_CHIEF_MODERATOR_MODERATION,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
      // if (response.data && response.data.message) {
      //   toastr.error(response.data.message);
      // }
    } catch (error) {
      dispatch(hideLoader());
      dispatch({
        payload: {},
        type: SET_CHIEF_MODERATOR_MODERATION,
      });
      handleError(error);
    }
  };
};


export const getSubjectBarcodes = (examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_SUBJECT_CODE_ROLLNO}/${examId}/${subjectId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_SUBJECT_CODE_ROLLNO,
        });
        handleResponseMessage(response);
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const getExamBarcodes = (examId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${GET_EXAM_CODE_ROLLNO}/${examId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (response) {
        dispatch({
          payload: response.data,
          type: SET_EXAM_CODE_ROLLNO,
        });
      }

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};


export const uploadInterviewMarks = (
  data,
  examId,
  cancelModal,
  resetData
) => {
  const session = JSON.parse(sessionStorage.getItem("session"));
  let token = session.jwtResponse && session.jwtResponse.token;
  let formData = new FormData();
  if (data.file) {
    formData.append("file", data.file);
    formData.append("type", "interviewMarks");
  }
  let response;
  let header = {
    Authorization: `Bearer ${token}`,
    "Content-Type": "multipart/form-data",
    Accept: "application/json",
    type: "formData",
  };

  return async (dispatch) => {
    try {
      response = await API.post(
        `${UPLOADINTERVIEWDATA}/${examId}`,
        formData,
        {
          headers: header,
        }
      );
      if (response) {
        if (response.data !== "") {
          const lines = response.data.split('\n');
          const count = parseInt(lines[0].split(':')[1].trim());

          let successMessage;

          if (lines.length > 3) {
            successMessage = count === 0
              ? 'No records added.'
              : `${count} records have been added successfully.`;

            const errorCsvContent = lines.slice(3).join('\n');
            FileDownload(errorCsvContent, `Data_interviewMarks.csv`);
          } else {
            successMessage = count === 0
              ? 'No records added.'
              : `${count} records have been added successfully.`;
          }

          if (count === 0) {
            toastr.warning(successMessage);
          } else {
            toastr.success(successMessage);
          }
        }
        cancelModal();
        resetData();
      }
    } catch (error) {
      handleError(error);
    }
  };
};


// export const getObjectiveStatusflag = (examId, setSaveButtonFlag,subjectId) => {
//   return async (dispatch) => {
//     dispatch(showLoader());
//     const session = JSON.parse(sessionStorage.getItem("session"));
//     let token = session.jwtResponse && session.jwtResponse.token;
//     try {
//       let response = await API.get(`${GET_OBJECTIVE_STATUS_FLAG}?examid=${examId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (response) {
//         dispatch({
//           payload: response.data,
//           type: SET_OBJECTIVE_STATUS_DATA_FLAG,
//         });
//       }
//       dispatch(hideLoader());
//     } catch (error) {
//       dispatch(hideLoader());
//       dispatch({
//         payload: [],
//         type: SET_OBJECTIVE_STATUS_DATA_FLAG,
//       });
//       if (error && error.response) {
//         let errorMessage =
//           error && error.response && error.response.data
//             ? error.response.data.message
//             : error.message;
//         toastr.error(errorMessage);
//         // setSaveButtonFlag(true)
//         return;
//       }
//     }
//   };
// };

export const getObjectiveStatusflag = (
  examId,
  setSaveButtonFlag,
  subjectId = null
) => {
  return async (dispatch) => {
    dispatch(showLoader());

    const session = JSON.parse(sessionStorage.getItem("session"));
    const token = session?.jwtResponse?.token;

    try {
      let url = `${GET_OBJECTIVE_STATUS_FLAG}?examid=${examId}`;

      if (subjectId) {
        url += `&subjectid=${subjectId}`;
      }

      const response = await API.get(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("API Response", response.data);
      dispatch({
        payload: response.data,
        type: SET_OBJECTIVE_STATUS_DATA_FLAG,
      });

      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());

      dispatch({
        payload: [],
        type: SET_OBJECTIVE_STATUS_DATA_FLAG,
      });

      if (error?.response) {
        const errorMessage =
          error?.response?.data?.message || error.message;

        toastr.error(errorMessage);

        // Uncomment if required
        // setSaveButtonFlag(true);
      }
    }
  };
};

export const getAnswerKeySetList = (examid, subjectid, setId) => {
  return async (dispatch) => {
    dispatch(showLoader());
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      let response = await API.get(`${ANSWER_KEY_SET_LIST}?examid=${examid}&subjectid=${subjectid}&setid=${setId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response) {
        dispatch({
          payload: response.data,
          type: SET_ANSWER_KEY_SET_LIST,
        });
      }
      dispatch(hideLoader());
    } catch (error) {
      dispatch(hideLoader());
      handleError(error);
    }
  };
};

// Replace OLD getQuestionSets with this NEW API version

export const getQuestionSets = (advertisementId, examId, subjectId) => {
  return async (dispatch) => {
    dispatch(showLoader());

    try {
      const session = JSON.parse(sessionStorage.getItem("session"));
      const token = session?.jwtResponse?.token;
      const response = await API.get(
        `/epms/api/v1/admin/answerkey/getsets?advertisementId=${advertisementId}&examId=${examId}&subjectId=${subjectId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch({
        type: SET_QUESTION_SET_LIST,
        payload: response.data,
      });
    } catch (error) {
      console.error("getQuestionSets Error:", error);
      console.error("Status:", error?.response?.status);
      console.error("Response Data:", error?.response?.data);

      handleError(error);
    } finally {
      dispatch(hideLoader());
    }
  };
};

export const getChiefModeratorCandidateCountByPercentage =
  (examId, subjectId, data) => {
    return async (dispatch) => {
      dispatch(showLoader());

      const session = JSON.parse(sessionStorage.getItem("session"));
      let token = session.jwtResponse && session.jwtResponse.token;

      try {
        const response = await API.post(
          `/epms/api/v1/admin/chiefmoderator/percentage/candidatecount/${examId}/${subjectId}`,
          data,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response) {
          dispatch({
            type: "GET_CHIEF_MODERATOR_PERCENTAGE_COUNT",
            payload: response.data,
          });
        }

        dispatch(hideLoader());
      } catch (error) {
        dispatch(hideLoader());

        console.log("Percentage API Error:", error?.response);

        toastr.error(
          error?.response?.data?.message ||
          "Unable to fetch percentage candidate count"
        );
      }
    };
  };

export const getInterviewScrutinyCandidates = (examId) => {
  return async (dispatch) => {
    const session = JSON.parse(sessionStorage.getItem("session"));
    let token = session.jwtResponse && session.jwtResponse.token;
    try {
      const response = await API.get(
        `/epms/api/v1/admin/interview/candidates?examId=${examId}`
      );

      dispatch({
        type: GET_INTERVIEW_SCRUTINY_CANDIDATES,
        payload: response.data,
      });
    } catch (error) {
      console.error("Error fetching scrutiny candidates:", error);
    }
  };
};

export const saveInterviewStatus = (data) => async (dispatch) => {
    try {
        const session = JSON.parse(sessionStorage.getItem("session"));
        let token = session.jwtResponse && session.jwtResponse.token;

        const response = await API.post(
            "/epms/api/v1/admin/interview/status",
            data,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        dispatch({
            type: SAVE_INTERVIEW_STATUS,
            payload: response.data,
        });

        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};